import { render, staticRenderFns } from "./NoteInput.vue?vue&type=template&id=0ca34fe2&"
import script from "./NoteInput.vue?vue&type=script&lang=js&"
export * from "./NoteInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports